<template>
  <div class="form-group">
    <label :style="'color:' + template.style.surveyTextColor" class="title-bold" for="email">{{ questionText }} {{ mandatoryQuestion ? '' : '(Opcional)' }}</label>
    <input
      type="email"
      class="form-control"
      id="email"
      :style="template.style.surveyBgColor ? {backgroundColor: template.style.surveyBgColor, color: template.style.surveyTextColor}: {color: template.style.surveyTextColor}" 
      name="email"
      :placeholder="getPlaceHolder"
      v-model="qtAnwser"
      v-on:keyup.enter="enterKey"
      v-on:keyup="allKeys"
      :disabled="processingApi"
    />

    <div
      class="q-buttonlist-answer mt-3"
      vs-align="center"
      vs-type="flex"
      vs-justify="space-around"
      v-show="showOptions"
    >
      <vs-button
        vs-type="flex"
        vs-justify="center"
        v-for="(opt, index) in optionsBase1"
        v-bind:key="index"
        type="flat"
        class="btnOtionList"
        v-on:click="chooseOption(opt)"
        >{{ opt }}</vs-button
      >
    </div>
  </div>
</template>

<script>
/*
 import { Survey } from "../../../services/Survey.js";
 const s = new Survey;
 */

export default {
  name: "Survey-Question-Text",
  data: () => ({
    qtAnwser: "",
    dataOk: false,
    showOptions: false,
    optionsBase1: [
      "@gmail.com",
      "@yahoo.com",
      "@outlook.com",
      "@me.com",
      ".com.br",
      ".com"
    ],
    optionsBase2: [".com.br", ".com"],
    options: [],
    processingApi: false,
  }),
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  computed: {
    getPlaceHolder() {
      if (this.placeHolder) return this.placeHolder;
      else return this.$t('type_answer_here');
    },
    template() {
      return this.$store.state.template;
    }
        },
        watch: {
            qtAnwser() {
                this.allKeys();
            }
        },
  mounted() {
    this.qtAnwser = this.$store.getters.answerValue(this.questionId);
    this.focusInput();
  },
  updated() {
    this.focusInput();
  },
  props: {
    questionText: { type: String },
    questionId: { type: Number },
    placeHolder: { type: String },
    mandatoryQuestion: { type: Boolean }
  },
  methods: {
    focusInput() {
      this.$refs.fc.$el.focus();
    },
    validEmail: function(email) {
      if (!email.length) {
        if (!this.mandatoryQuestion) {
          return true
        }
      }
      if (email.length >= 5) {
        if (email.includes("@") && email.includes(".") && !email.endsWith(".")) return true;
      } else return false;
    },
    allKeys() {
      this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
      this.showOptions = true;
    },
    enterKey() {
      if (this.validEmail(this.qtAnwser)) {
        this.processingApi = true
        this.$emit("QuestionAnwered", this.qtAnwser, this.questionId)
          .then(() => this.processingApi = false);
      } else {
        this.$emit("ErrorOccured", this.invalidEmailMessage(), this.questionId)
      }
    },
    invalidEmailMessage() {
      return this.template.survey && String(this.template.survey.iso3).toUpperCase() === "FRA"
        ? "Email invalide."
        : "Email inválido.";
    },
    chooseOption(text) {
      if (this.validEmail(this.qtAnwser)) {
        this.enterKey()
      } else {
        this.qtAnwser = this.qtAnwser + text;
        this.showOptions = false;
        this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
      }
    }
  }
};
</script>

<style scoped>
.title-bold{
  font-family:'OxaniumBold';
}
</style>
